import { VerboseFormattingArg } from "@fullcalendar/core/internal";
import { isMobile } from "@gymflow/common";
import moment from "moment-timezone";

export function DayGridMonthTitleFormat(date: VerboseFormattingArg) {
  if (isMobile()) return "";
  return moment(date.date).format("MMMM");
}
